import React, { useEffect } from "react";
import { CheckboxGroup } from "../../../../comum";
import { connect } from "react-redux";
import {
  getPeriodicidadeSelecionada,
  getUsarUltimaNegociacaoMes,
  selecionarUltimaNegociacaoMes,
} from "../../../../../state";
import { ID_PERIODICIDADE_MENSAL } from "../../../../../model";
import { compose, mapProps } from "recompose";
import { withI18n } from "@quantum/i18n";

import "./checkbox-ultima-negociacao-mes.css";

const enhance = compose(
  withI18n,
  mapProps(({ translate }) => ({
    description: translate("configuracaoRelatorio.usarUltimaNegociacaoMes"),
  })),
  connect(
    state => ({
      selected: getUsarUltimaNegociacaoMes(state),
      periodicidade: getPeriodicidadeSelecionada(state),
    }),
    dispatch => ({
      onChange: (ids: Array<Id>) =>
        dispatch(selecionarUltimaNegociacaoMes(ids.length > 0)),
    })
  )
);

const CheckboxUltimaNegociacaoMes = ({
  selected = false,
  periodicidade,
  description,
  onChange,
}) => {
  useEffect(() => {
    if (periodicidade !== ID_PERIODICIDADE_MENSAL && selected) {
      onChange([]);
    }
  });

  if (periodicidade !== ID_PERIODICIDADE_MENSAL) {
    return null;
  }

  return (
    <div className="ConfiguracaoMedida ConfigUltimaNegociacao">
      <CheckboxGroup
        nome="ultimaNegociacaoMes"
        itens={[{ id: 1, description }]}
        campoId="id"
        campoDescricao="description"
        itensSelecionados={selected ? [1] : []}
        onChange={onChange}
      />
    </div>
  );
};

export default enhance(CheckboxUltimaNegociacaoMes);
